/* Vudi: Sözleşme onay kutusu işaretlenmeden "Ödeme"ye basılırsa görünür uyarı gösterir (Terms & Conditions uygulaması uyarıyı göstermiyordu). */
(function(){
  if (window.__vudiTncInit) return; window.__vudiTncInit = true;
  var css = document.createElement('style');
  css.textContent = '.vudi-tnc-error{outline:2px solid #c0392b;outline-offset:4px;border-radius:6px;animation:vudiTncShake .35s}'+
    '.vudi-tnc-msg{color:#c0392b;font-size:13px;line-height:1.4;margin:8px 0 4px;font-weight:600}'+
    '@keyframes vudiTncShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}';
  document.head.appendChild(css);
  function isTr(){ return (document.documentElement.lang || '').toLowerCase().indexOf('tr') === 0; }
  function msgText(){
    if (isTr()) return (window.newdata && window.newdata.alertText) || 'Devam etmek için lütfen Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi\'ni onaylayın.';
    return 'Please accept the Preliminary Information Form and the Distance Sales Agreement to continue.';
  }
  function findBox(btn){
    var id = btn.getAttribute('data-tnc-id');
    var cb = id ? document.getElementById(id) : null;
    if (!cb) { var scope = btn.closest('.cart__ctas, .cart-summary__inner, form, cart-drawer-component, dialog') || document; cb = scope.querySelector('input[data-tncbox]'); }
    return cb;
  }
  function clearErr(cb){
    var box = cb.closest('.gm_tncContainer') || cb.parentElement;
    box.classList.remove('vudi-tnc-error');
    var m = box.parentElement && box.parentElement.querySelector('.vudi-tnc-msg'); if (m) m.remove();
  }
  function showErr(cb){
    var box = cb.closest('.gm_tncContainer') || cb.parentElement;
    box.classList.remove('vudi-tnc-error'); void box.offsetWidth; box.classList.add('vudi-tnc-error');
    var m = box.parentElement.querySelector('.vudi-tnc-msg');
    if (!m) { m = document.createElement('p'); m.className = 'vudi-tnc-msg'; m.setAttribute('role','alert'); box.insertAdjacentElement('afterend', m); }
    m.textContent = msgText();
    box.scrollIntoView({behavior:'smooth', block:'center'});
    if (!cb.__vudiBound) { cb.__vudiBound = true; cb.addEventListener('change', function(){ if (cb.checked) clearErr(cb); }); }
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    var cb = findBox(btn);
    if (!cb || cb.checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showErr(cb);
  }, true);
})();
